import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";
import productData from "../Datas/productData";
import siteConfig, { formatPrice } from "../Datas/siteConfig";
import "../css/main.scss";

const editSections = [
  {
    key: "hats",
    title: "Our hats",
    copy: "Every hat is a piece of art, made by hand with care and affection.",
    image: "/main/hero-hats.jpg",
    category: "Hats",
    featuredIds: [1, 2, 3, 4, 5, 6, 11, 12],
    position: "center 35%",
  },
  {
    key: "ready",
    title: "Ready to wear",
    copy: "Freehand paintings translated into pieces that move with you.",
    image: "/main/hero-ready.jpg",
    category: "Ready to wear",
    featuredIds: [13, 14, 15, 16, 17, 18, 19, 20],
    position: "center 30%",
  },
  {
    key: "objects",
    title: "Little works of art",
    copy: "Playful accessories, small editions and gifts for bright days.",
    image: "/main/hero-accessories.jpg",
    category: "Accessories",
    featuredIds: [21, 22, 23, 24, 25, 26, 29, 30, 31],
    position: "center 42%",
  },
];

function Main() {
  const { addToCart, toggleWishlist, isWishlisted } = useContext(CartContext);

  const addQuickItem = (product) => {
    addToCart(product.id, 1, product.sizes[0], product.colors[0]);
  };

  return (
    <main className="home" id="main-content">
      <h1 className="visually-hidden">
        {siteConfig.brandName} — {siteConfig.shortDescription}
      </h1>

      {editSections.map((section, sectionIndex) => {
        const products = section.featuredIds
          .map((id) => productData.find((product) => product.id === id))
          .filter(Boolean);

        return (
          <React.Fragment key={section.key}>
            <section
              className={`home-hero home-hero--${section.key}`}
              aria-labelledby={`${section.key}-title`}
            >
              <img
                src={section.image}
                alt=""
                loading={sectionIndex === 0 ? "eager" : "lazy"}
                style={{ objectPosition: section.position }}
              />
              <div className="home-hero__shade" aria-hidden="true" />
              <div className="home-hero__content">
                <h2 id={`${section.key}-title`}>{section.title}</h2>
                <p>{section.copy}</p>
                <Link
                  to={`/shop?category=${encodeURIComponent(section.category)}`}
                  className="button button--light"
                >
                  View all
                </Link>
              </div>
            </section>

            <section
              className="home-collection"
              aria-label={`${section.title} selection`}
            >
              <div className="home-collection__track">
                {products.map((product, productIndex) => (
                  <article className="product-card" key={product.id}>
                    <div className="product-card__media">
                      <Link
                        to={`/shopDetails/${product.id}`}
                        aria-label={`View ${product.name}`}
                      >
                        <img
                          src={product.image}
                          alt={product.name}
                          loading={sectionIndex === 0 && productIndex < 4 ? "eager" : "lazy"}
                        />
                      </Link>
                      <button
                        type="button"
                        className={`product-card__wish${
                          isWishlisted(product.id) ? " is-active" : ""
                        }`}
                        onClick={() => toggleWishlist(product.id)}
                        aria-label={`${
                          isWishlisted(product.id) ? "Remove" : "Add"
                        } ${product.name} ${
                          isWishlisted(product.id) ? "from" : "to"
                        } wishlist`}
                        aria-pressed={isWishlisted(product.id)}
                      >
                        <span aria-hidden="true">♡</span>
                      </button>
                      <button
                        type="button"
                        className="product-card__quick-add"
                        onClick={() => addQuickItem(product)}
                      >
                        {product.sizes.length > 1 ? "Add first size" : "Add to bag"}
                      </button>
                    </div>
                    <div className="product-card__info">
                      <h3>
                        <Link to={`/shopDetails/${product.id}`}>{product.name}</Link>
                      </h3>
                      <div className="product-card__price">
                        <span>{formatPrice(product.price)}</span>
                        {product.compareAtPrice && (
                          <s>{formatPrice(product.compareAtPrice)}</s>
                        )}
                      </div>
                    </div>
                  </article>
                ))}
              </div>
              <Link
                className="home-collection__more"
                to={`/shop?category=${encodeURIComponent(section.category)}`}
              >
                {sectionIndex === editSections.length - 1 ? "See more" : "View more"}
              </Link>
            </section>
          </React.Fragment>
        );
      })}
    </main>
  );
}

export default Main;
